export default __webpack_public_path__ + "static/media/profile-default-big.521eb5ff.svg";